import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { PrFormSelectListComponent } from '@app/components/pr-form/pr-form-select-list/pr-form-select-list.component';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { PledgeRead } from '@app/forms/subscription/definition/interface/Pledge';
import { CommandEnum } from '@app/forms/subscription/definition/interface/enum';
import { ProductSearchItem } from '@app/forms/subscription/definition/interface/product';
import * as _ from 'lodash';
import moment from 'moment';
import { Observable, tap } from 'rxjs';
import { InfoOption } from '../../components/info/info.component';
import { ProductService, ProductState } from '../../services/product.service';
import { infoOption } from '../../services/ref';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'product-form',
    templateUrl: './product-form.component.html',
    styleUrls: ['./product-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProductFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  @ViewChild('formSelectList', {
    static: false,
    read: PrFormSelectListComponent,
  })
  formSelectList: PrFormSelectListComponent;
  criteriaForm: UntypedFormGroup;
  searchTerm: UntypedFormControl;
  length = 0;
  pageSize = 5;
  _ = _;
  vm$: Observable<ProductState>;
  error: ValidationErrors = null;
  option: InfoOption = infoOption;
  isConsultant: boolean = false;
  pledge: PledgeRead;
  constructor(
    private cdr: ChangeDetectorRef,
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    public route: ActivatedRoute,
    public product: ProductService,
  ) {
    super(formConstructor);
    this.criteriaForm = this.formBuilder.group({
      autocomplete: [],
    });
  }
  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }
  ngOnInit(): void {
    this.subscriptionFacade.initForm(this);
    this.pledge = this.subscriptionFacade.getPledge();

    const { criteria } = this.product.getStateSnapshot();
    this.vm$ = this.product.vm$.pipe(
      tap(state => {
        this.formSelectList && (this.formSelectList.loading = state?.loading);
      }),
    );
    this.searchTerm = this.product.buildSearchTermControl();
    this.searchTerm.patchValue(criteria.autocomplete, { emitEvent: false });
    this.isConsultant = !!this.subscriptionFacade?.getUser()?.sessionConsultant;
  }
  onProductSelect(product) {
    const { parameters = {} } = this.pledge || {};
    const { scpiOwnershipType = 'PLEINE_PROPRIETE_CASH' } = parameters as any;

    const productSelected = {
      type: product.type,
      productId: product.id,
      productName: product.name,
      parameters: {
        scpiPartDivisible: ['USUFRUIT', 'NU_PROPRIO'].includes(
          scpiOwnershipType,
        )
          ? false
          : product?.scpiPartDivisible,
      },
    };
    let newControl = this.formBuilder.group(this.createModel(productSelected));
    let formArray = this.form.controls.products as UntypedFormArray;
    newControl.setValue({ ...newControl.value });
    formArray.push(newControl);

    this.form.markAsDirty();
  }
  onProductDeselect(product) {
    let formArray = this.form.controls.products as UntypedFormArray;
    let control = formArray.controls.findIndex(
      c => c.value.productId == product.id,
    );
    formArray.removeAt(control);
    this.form.markAsDirty();
  }
  changeProductsPage(event) {}
  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.selectErrorInputAndScroll(this);

    const productIdsArray = this.form?.value?.products.map(
      product => product.productId,
    );
    if (!productIdsArray.length) {
      this.form.get('products').setErrors({
        incorrect: true,
        message: 'Veuillez sélectionner au moins une SCPI',
      });
    }
    this.error = this.form.get('products').errors;

    if (this.form.valid) {
      this.subscriptionFacade.setCommand([
        CommandEnum.COMPLETE_PRODUCTS_DATA,
        CommandEnum.GENERATE_ADDITIONAL_QUESTIONS,
      ]);
      this.subscriptionFacade.submitPledge(this, 'products');
    }
  }
  prev() {
    this.subscriptionFacade.previousStep();
  }
  getIcon(option: ProductSearchItem) {
    const icons = [];
    if (option && option.electronicSignature && this.isConsultant)
      icons.push('fingerprint');
    if (
      option &&
      this.isConsultant &&
      (option.mappedSubscriptionForm ||
        (this.pledge?.parameters?.scpiOwnershipType &&
          option?.realestateMappedSubscriptionForm.includes(
            this.pledge.parameters.scpiOwnershipType,
          )))
    )
      icons.push('task');
    if (option && option.favorite) icons.push('star');

    if (option && option.subscriptionFluxAllowed) icons.push('cast');

    return icons.join(' ');
  }
  getTooltipIcon(option: ProductSearchItem) {
    if (
      this.isConsultant &&
      (option.mappedSubscriptionForm ||
        (this.pledge?.parameters?.scpiOwnershipType &&
          option?.realestateMappedSubscriptionForm.includes(
            this.pledge?.parameters.scpiOwnershipType,
          )))
    ) {
      let tooltip = 'BS mappé';
      if (option.mappingDate) {
        tooltip += ' le ' + moment(option.mappingDate).format('DD-MM-YY');
      }
      if (option.electronicSignature) {
        tooltip += ' en signature électronique';
      }
      if (option.subscriptionFluxAllowed) {
        tooltip += ' et dispo en flux API';
      }
      return tooltip;
    }
  }
}
